define(['../validation', '../../util.js'], function(validation, util) {
    'use strict';
    validation.addCustomValidationRule('equality', function(val, options) {
        return util.isEqual(val, options.compareTo);
    });
});
